import React, { useState, useEffect } from 'react';
import { ReadOnlyBlock } from '@blumtechgroup/blum-react-core-components';
import { StringUtils } from '@blumtechgroup/blum-ui-utils';
import { Grid } from '@mui/material';
import { useQuery } from '@apollo/client';
import { selectClinicianUserInitQuery, ClinicianUser } from './queries';

interface Props {
  clinicianId: string;
  handleEdit: () => void;
}

const ViewClinicianUsersComponent = ({ clinicianId, handleEdit }: Props): React.ReactElement => {
  const [user, setUser] = useState<ClinicianUser>({
    first_name: '',
    last_name: '',
    email: '',
    active: true,
    organisation: {
      name: '',
    },
    location: {
      name: '',
    },
    license: {
      license_type: {
        name: '',
      },
    },
  });
  const { data: clinicianUserInitData } = useQuery(selectClinicianUserInitQuery(clinicianId), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (clinicianUserInitData) {
      setUser(clinicianUserInitData.users_clinician_by_pk);
    }
  }, [clinicianUserInitData]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <ReadOnlyBlock
          items={[
            { label: 'Full Name', value: StringUtils.stringFromArray([user.first_name, user.last_name]) },
            { label: 'Email', value: user.email },
            { label: 'Active', value: StringUtils.booleanToYesNo(user.active) },
            { label: 'License Type', value: user.license ? user.license.license_type.name : 'No license assigned' },
          ]}
          handleEdit={handleEdit}
        />
      </Grid>
    </Grid>
  );
};

export default ViewClinicianUsersComponent;
